module.exports = __webpack_public_path__ + "img/EmoQi-Logo-FeMale2.797a595c.gif";